<metutors-modal [showModal]="showModal" (closeModal)="closeModal.emit()" [size]="'large'"
                [template]="template" [panelClass]="'filter-blur-10'">
  <ng-template #template>
    <ng-container *ngLet="(roles$ | async)! as roles">
      <ng-container *ngLet="(affiliate$ | async)! as affiliate">
        <div class="row">
          <div class="col-md-6 position-relative order-2-sm">
            <div class="hints position-sticky top-0 pe-4">
              <h2>{{ 'GET_RELIABLE_ANSWERS_HOMEWORK_PROBLEMS' | translate }}</h2>
              <ul class="p-0 mt-4 mb-0">
                <li><span class="ms-4" [innerHTML]="'GET_INSTANT_STEP_SOLUTIONS' | translate"></span></li>
                <li><span class="ms-4" [innerHTML]="'FREE_ACCESS_PREMIUM_GPTS_30_DAYS' | translate"></span></li>
                <li><span class="ms-4" [innerHTML]="'YOU_GOT_SUBJECT_SPECIFIC_GPTS' | translate"></span></li>
                <li><span class="ms-4" [innerHTML]="'TEST_PREP_GPTS_ETCS' | translate"></span></li>
                <li><span class="ms-4" [innerHTML]="'TRANSFORM_LENGTHLY_VIDEOS_CONCISE_INSIGHTS_GPT' | translate"></span></li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order-1-sm">
            <metutors-signup-form [accountType]="(userType$ | async)!" 
                                  [roles]="(roles$ | async)!"
                                  [title]="title"
                                  [affiliate]="affiliate"
                                  [returnUrl]="returnUrl"
                                  [isModal]="true"
                                  [error]="(error$ | async)!"
                                  [submitLabel]="'SIGNUP_NOW'"
                                  [isLoading]="(isLoading$ | async)!"
                                  [authLoading]="(authLoading$ | async)!"
                                  (register)="onRegister($event)"
                                  (changeStep)="changeStep(1, '', $event)"
                                  (signinClicked)="signinClicked.emit($event)"
                                  (openRolesDialog)="openRolesDialog($event, roles)">
            </metutors-signup-form>
          </div>
        </div>

        <span class="hint position-absolute bottom-0 left-0 w-100-sm d-inline-block position-unset-sm mt-15-sm"
              [innerHTML]="'POWERED_BY_OPEN_AI' | translate">
        </span>
      </ng-container>
    </ng-container>
  </ng-template>
</metutors-modal>
